
export default {
    name: 'debug-info',
    install(Vue) {
        Vue.component('debugInfo', this)
    },
    data() {
        return {
            show: false
        }
    },
    template: ''
}
